import { html, attr, Use, Value, computedOf, Ensure } from '@tempots/dom'
import { Location, Anchor } from '@tempots/ui'
import { Icon } from '@tempots/beatui'
import type { LocationData } from '@tempots/ui'

export interface NavLinkOptions {
  href: Value<string>
  iconName: Value<string>
  label: Value<string>
  badge?: Value<number | undefined>
}

export function NavLink({ href, iconName, label, badge }: NavLinkOptions) {
  return Use(Location, (handle) => {
    const isActive = computedOf(
      handle.location,
      href
    )((loc: LocationData, h: string) => loc.pathname === h)

    return Anchor(
      { href },
      attr.class(
        isActive.map((active: boolean) =>
          active
            ? 'flex items-center gap-3 px-3 py-2 text-sm font-medium text-brand-700 bg-brand-50 rounded-lg'
            : 'flex items-center gap-3 px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 rounded-lg'
        )
      ),
      Icon({ icon: iconName }, attr.class('w-5 h-5')),
      html.span(label),
      Ensure(badge, (b) =>
        html.span(
          attr.class(
            'ml-auto bg-gray-200 text-gray-600 px-2 py-0.5 rounded-full text-xs'
          ),
          b.map((num) => String(num))
        )
      )
    )
  })
}
